<template>
  <v-app-bar
      elevation="0"
      class="main-header"
      height="64"
      fixed
      color='white'
      dark
  >
    <v-toolbar-title>
      <router-link :to="gotoHome">
        <v-img v-if="customer.logoUrl === null" height="25" contain src="@/assets/logo-viewelevator-blue.png"></v-img>
        <v-img v-else height="25" contain :src="getPath()"></v-img>
      </router-link>
    </v-toolbar-title>

    <div class="header-links d-none d-sm-flex ml-10">
        <v-btn
            v-for="(item, i) in checkRolesAndMain(navLinks)"
            :key="i"
            text
            active-class="navbar-link--active"
            :to="item.route"
            class="text-capitalize primary--text"
        >

          {{ $t('navbar:links.' + item.text) }}
        </v-btn>

      <v-menu
          v-if="isAdmin"
          min-width="180"
          offset-y
          bottom
          nudge-bottom="14"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              text
              v-bind="attrs"
              v-on="on"
              class="text-capitalize primary--text"
          >
            {{ $t('display/navbar:admin') }}
            <v-icon class="ml-1">expand_more</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group color="primary">
            <v-list-item
                v-for="(item, i) in adminLinks"
                :key="i"
                :to="item.route"
                link
                @click="item.action ? item.action() : null"
                class="primary--text"
            >
              <v-list-item-action class="mr-2" v-if="item.icon">
                <v-icon class="greyTint--text">{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="primary--text">
                  {{ $t('settings/navbar:admin.' + item.text) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </div>
    <v-spacer></v-spacer>

    <UserMenu
      :user="user"
    />

    <!-- LanguageSelector -->
    <LanguageMenu />
  </v-app-bar>
</template>

<script>
import {Role} from "@/modules/core/data/roles";
import config from '@/config';
import UsersService from "@/modules/core/services/users-service";
import DataUtils from "@/modules/core/services/data-utils";
import UserMenu from "@/modules/core/components/Header/UserMenu";
import LanguageMenu from "@/modules/core/components/Header/LanguageMenu";
import Users from '@/modules/core/data/users';
import ModuleSwitcher from '@/plugins/module-switcher';
import Customer from "@/modules/core/data/customer";
import CustomerService from "@/modules/core/services/customer-service";

export default {
  name: 'SettingsHeader',
  components: {
    UserMenu,
    LanguageMenu
  },
  data: function(){
      return {
        config,
        searchCollapse: true,
        ownsDisplay: true, //may access the media instance
        messageBadge: true,
        user: [],
        customer: {},
        navLinks: [
          {
            text: 'advert',
            route: `/${this.$store.state.manager.displayModuleUrl}`,
            main: false,
            roles: [Role.Admin, Role.Operator, Role.Manager, Role.Worker]
          },
          {
            text: 'liftbook',
            route: `/${this.$store.state.manager.bookModuleUrl}`,
            main: false,
            roles: [Role.Admin, Role.Operator, Role.Manager, Role.Worker]
          }
        ],
        adminLinks: [
          {
            icon: 'public',
            text: 'countries',
            route: `/${this.$store.state.manager.settingsModuleUrl}/country`,
            main: false
          },
          {
            icon: 'public',
            text: 'province',
            route: `/${this.$store.state.manager.settingsModuleUrl}/province`,
            main: false
          },
          {
            icon: 'fire_extinguisher',
            text: 'emergency-center',
            route: `/${this.$store.state.manager.settingsModuleUrl}/emergency-center`,
            main: false
          },
          {
            icon: 'invert_colors',
            text: 'meta',
            route: `/${this.$store.state.manager.settingsModuleUrl}/metainfo`,
            main: false
          },
          {
            icon: 'settings',
            text: 'option',
            route: `/${this.$store.state.manager.settingsModuleUrl}/option`,
            main: false
          },
          {
            icon: 'api',
            text: 'rest',
            route: `/${this.$store.state.manager.settingsModuleUrl}/rest-external`,
            main: false
          },
          {
            icon: 'date_range',
            text: 'scheduler',
            route: `/${this.$store.state.manager.settingsModuleUrl}/scheduler`,
            main: false
          },
          {
            icon: 'settings',
            text: 'setting',
            route: `/${this.$store.state.manager.settingsModuleUrl}/setting`,
            main: false
          },
          {
            icon: 'style',
            text: 'tag',
            route: `/${this.$store.state.manager.settingsModuleUrl}/tag`,
            main: false
          },
          {
            icon: 'update',
            text: 'update',
            route: `/${this.$store.state.manager.settingsModuleUrl}/update`,
            main: false
          },
          {
            icon: 'settings',
            text: 'cas',
            route:  `/${this.$store.state.manager.settingsModuleUrl}/customer`,
            main: false
          },
          {
            icon: 'call_merge',
            text: 'merge',
            route: `/${this.$store.state.manager.settingsModuleUrl}/merge#building`,
            main: false
          }
        ]
      }
  },
  computed: {
    DRAWER_STATE: {
      get() {
        return this.drawer
      },
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin);
      }
      return false;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    gotoHome() {
      let resultLink = '/home';

      if (this.hasRole([Role.Admin])) {
        return resultLink;
      }

      if (ModuleSwitcher.isOnlyDisplay()) {
        resultLink = ModuleSwitcher.getDisplayHomeUrl();
      } else if (ModuleSwitcher.isOnlyLiftBook()) {
        resultLink = `/${this.$store.state.manager.bookModuleUrl}`;
      }

      return resultLink;
    }
  },
  methods: {
    getPath() {
      if (this.customer === undefined || this.customer.logoUrl === undefined)
        return;

      return process.env.VUE_APP_ROOT_HOST + this.customer.logoUrl + "?" + Math.random();
    },
    checkRolesAndMain: function (links) {
      var self = this;
      return links.filter(function (link) {
        return (!link.main || (link.main && self.isMain))
            && self.hasRole(link.roles);
      })
    },
    hasRole(roles) {
      if (this.currentUser && this.currentUser.roles) {
        for (let i = 0; i < roles.length; i++) {
          if (this.currentUser.roles.includes(roles[i])) {
            return true;
          }
        }
      }
      return false;
    }
  },
  created() {
    UsersService.readProfileFromAPI(
      (resp) => {
        var response = DataUtils.parseDataToSingleObject(resp.data, Users);
        if (response == null) {
          this.$logger.error("Failed to receive user data!");
        } else {
          this.user = response;
          CustomerService.readProfileFromAPI(
              (resp) => {
                var response = DataUtils.parseDataToSingleObject(resp.data, Customer);
                this.customer = response;
              })
        }
      }
    )
  }
};
</script>

<style src="@/modules/core/components/Header/Header.scss" lang="scss"></style>
